import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

/**
 * Hero Slider - Main featured products carousel with navigation
 */
export class HeroSlider {
    constructor(element) {
        this.element = element;
        this.viewport = element.querySelector('.embla__viewport');
        this.prevBtn = element.querySelector('.embla__prev');
        this.nextBtn = element.querySelector('.embla__next');
        this.dotsContainer = element.querySelector('.embla__dots');

        if (!this.viewport) return;

        this.embla = EmblaCarousel(this.viewport, {
            loop: true,
            align: 'center',
            skipSnaps: false,
            containScroll: false
        }, [
            Autoplay({ delay: 5000, stopOnInteraction: false })
        ]);

        this.setupNavigation();
        this.setupDots();
    }

    setupNavigation() {
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => this.embla.scrollPrev());
        }
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => this.embla.scrollNext());
        }
    }

    setupDots() {
        if (!this.dotsContainer) return;

        const slides = this.embla.slideNodes();
        slides.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.className = 'embla__dot';
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            dot.addEventListener('click', () => this.embla.scrollTo(index));
            this.dotsContainer.appendChild(dot);
        });

        this.updateDots();
        this.embla.on('select', () => this.updateDots());
    }

    updateDots() {
        const dots = this.dotsContainer?.querySelectorAll('.embla__dot');
        if (!dots) return;

        const selected = this.embla.selectedScrollSnap();
        dots.forEach((dot, index) => {
            dot.classList.toggle('embla__dot--active', index === selected);
        });
    }
}

/**
 * Products Slider - Multi-slide carousel for product cards
 */
export class ProductsSlider {
    constructor(element) {
        this.element = element;
        this.viewport = element.querySelector('.embla__viewport');

        if (!this.viewport) return;

        this.embla = EmblaCarousel(this.viewport, {
            loop: false,
            align: 'start',
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
            breakpoints: {
                '(min-width: 768px)': { slidesToScroll: 2 },
                '(min-width: 1024px)': { slidesToScroll: 3 }
            }
        });

        this.setupNavigation();
    }

    setupNavigation() {
        const prevBtn = this.element.querySelector('.embla__prev');
        const nextBtn = this.element.querySelector('.embla__next');

        if (prevBtn) {
            prevBtn.addEventListener('click', () => this.embla.scrollPrev());
            this.embla.on('select', () => {
                prevBtn.disabled = !this.embla.canScrollPrev();
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', () => this.embla.scrollNext());
            this.embla.on('select', () => {
                nextBtn.disabled = !this.embla.canScrollNext();
            });
        }
    }
}

/**
 * Posts Slider - News cards carousel
 */
export class PostsSlider {
    constructor(element) {
        this.element = element;
        this.viewport = element.querySelector('.embla__viewport');

        if (!this.viewport) return;

        this.embla = EmblaCarousel(this.viewport, {
            loop: false,
            align: 'start',
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
            breakpoints: {
                '(min-width: 768px)': { slidesToScroll: 2 },
                '(min-width: 1024px)': { slidesToScroll: 3 }
            }
        });

        this.setupNavigation();
    }

    setupNavigation() {
        const prevBtn = this.element.querySelector('.embla__prev');
        const nextBtn = this.element.querySelector('.embla__next');

        if (prevBtn) {
            prevBtn.addEventListener('click', () => this.embla.scrollPrev());
            this.embla.on('select', () => {
                prevBtn.disabled = !this.embla.canScrollPrev();
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', () => this.embla.scrollNext());
            this.embla.on('select', () => {
                nextBtn.disabled = !this.embla.canScrollNext();
            });
        }
    }
}
